<template>
    <div id="vue-duels">
        <input id="duelData" name="duelData" type="hidden" v-model="jsonData" />
        <table>
            <template v-for="category in categories">
                <tr>
                    <th colspan="5">{{category.name}} - <a href="#" @click.prevent="removeCategory(category)"><i class="fe fe-x-circle"></i></a></th>
                </tr>
                <tr v-for="line in category.lines">
                    <td>{{line.name}}</td>
                    <td>{{line.value1}}</td>
                    <td>{{line.value2}}</td>
                    <td>{{line.best}}</td>
                    <td>
                        <a href="#" @click.prevent="editLine(category, line)"><i class="fe fe-edit"></i></a>
                        <a href="#" @click.prevent="removeLine(category, line)"><i class="fe fe-x-circle"></i></a>
                    </td>
                </tr>
                <tr>
                    <td><input placeholder="Nom" v-model="category.newLineName"></td>
                    <td><input placeholder="Valeur 1" v-model="category.newLineValue1"></td>
                    <td><input placeholder="Valeur 2" v-model="category.newLineValue2"></td>
                    <td><select v-model="category.newLineBest"><option :value="1">1</option><option :value="2">2</option></select></td>
                    <td><a href="#" @click.prevent="addLine(category)"><i class="fas" :class="category.newLineEditedLine ? 'fe fe-check-circle' : 'fe fe-plus-circle'"></i></a></td>
                </tr>
            </template>
        </table>
        <hr>
        <input v-model="newCategoryName" placeholder="Nom de la catégorie">
        <button @click.prevent="addCategory" type="button">Ajouter une catégorie</button>
    </div>
</template>

<script>
export default {
    props: ['data'],
    data () {
        return {
            categories: [],
            newCategoryName: '',
            jsonData: null
        };
    },
    methods: {
        addCategory() {
            this.categories.push({
                name: this.newCategoryName,
                lines: [],
                newLineName: '',
                newLineValue1: '',
                newLineValue2: '',
                newLineBest: 1,
                newLineEditedLine: null
            });
            this.newCategoryName = '';
            this.updateJsonData();
        },
        removeCategory (category) {
            this.categories.splice(this.categories.indexOf(category), 1);
            this.updateJsonData();
        },
        addLine (category) {
            if (category.newLineEditedLine) {
                category.newLineEditedLine.name = category.newLineName;
                category.newLineEditedLine.value1 = category.newLineValue1;
                category.newLineEditedLine.value2 = category.newLineValue2;
                category.newLineEditedLine.best = category.newLineBest;
            } else {
                category.lines.push({
                    name: category.newLineName,
                    value1: category.newLineValue1,
                    value2: category.newLineValue2,
                    best: category.newLineBest
                });
            }
            category.newLineName = '';
            category.newLineValue1 = '';
            category.newLineValue2 = '';
            category.newLineBest = 1;
            category.newLineEditedLine = null;
            this.updateJsonData();
        },
        editLine (category, line) {
            category.newLineEditedLine = line;
            category.newLineName = line.name;
            category.newLineValue1 = line.value1;
            category.newLineValue2 = line.value2;
            category.newLineBest = line.best;
        },
        removeLine (category, line) {
            category.lines.splice(category.lines.indexOf(line), 1);
            this.updateJsonData();
        },
        updateJsonData () {
            this.jsonData = encodeURIComponent(JSON.stringify(this.categories));
        }
    },
    mounted () {
        this.jsonData = this.data;
        this.categories = JSON.parse(decodeURIComponent(this.data || '[]'));
    },
};
</script>